import { fetch } from '@atlassian/eoc-fetch';

import {
	type CreateEscalationParams,
	type EscalationEntity,
	type UpdateEscalationParams,
	type UpdatePartialEscalationParams,
} from '../../../common/types';

const getBaseUrl = (teamId: string | undefined) => {
	if (teamId) {
		return `/v1/teams/${teamId}/escalations`;
	}

	return '/v1/escalations';
};

export const createEscalationEndpoint = (
	teamId: string | undefined,
	escalationPolicy: CreateEscalationParams,
) => {
	return fetch<EscalationEntity>(getBaseUrl(teamId), {
		method: 'POST',
		body: escalationPolicy,
	});
};

export const updateEscalationEndpoint = (
	teamId: string | undefined,
	escalationPolicy: UpdateEscalationParams,
) => {
	return fetch<EscalationEntity>(`${getBaseUrl(teamId)}/${escalationPolicy.id}`, {
		method: 'PUT',
		body: escalationPolicy,
	});
};

export const updatePartialEscalationEndpoint = (
	teamId: string | undefined,
	escalationPolicy: UpdatePartialEscalationParams,
) => {
	return fetch<EscalationEntity>(`${getBaseUrl(teamId)}/${escalationPolicy.id}`, {
		method: 'PATCH',
		body: escalationPolicy,
	});
};

export const deleteEscalationEndpoint = (
	teamId: string | undefined,
	id: EscalationEntity['id'],
) => {
	return fetch(`${getBaseUrl(teamId)}/${id}`, {
		method: 'DELETE',
		responseType: 'headers',
	});
};
